import React, { Component } from 'react';
import * as constants from '../constants.js';
import ReactGA from 'react-ga';

import character from '../assets/images/character-phone.png';

class GetTheApp extends Component {

  render() {
    return (
      <div className="GetTheApp">
        <div className="background-blue text-contrast">
          <div className="page-container-responsive">
            <div className="row space-top-5 space-5 space-top-sm-3 space-sm-4">
              <div className="col-sm-12 col-md-6">
                <h2><b>Download Tiny Doorman.</b></h2>
                <h3 className="space-4">Available on iOS and Android.</h3>
                <ReactGA.OutboundLink
                  eventLabel="downloadiOS"
                  to={constants.iOSAppURL}
                  className="app-button app-button-apple space-2">
                  Download on the App Store
                </ReactGA.OutboundLink>
                <ReactGA.OutboundLink
                  eventLabel="downloadAndroid"
                  to={constants.androidAppURL}
                  className="app-button app-button-android">
                  Android App on Google Play
                </ReactGA.OutboundLink>
              </div>
              <div className="col-sm-12 col-md-4 col-offset-2 text-center hide-sm">
                <img src={character} className="pull-right" alt="Tiny Doorman"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GetTheApp;



/** WEBPACK FOOTER **
 ** ./src/components/GetTheApp.js
 **/